<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table">

    <div class="tr layout-row layout-align-start-center" id="header">
      <div class="th flex">
        <span translate>Group Name</span>
        <bringoz-button *ngIf="allowSort"
                        type="tertiary"
                        size="lg"
                        (click)="sortTypeChangeEvent.emit('sortName')">
          <bringoz-icon [iconName]="sortType?.name === 'sortName' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>
      <div class="th flex" translate>External ID</div>
      <div class="th flex" translate>Branches</div>
      <div class="th flex" translate>Tags</div>
      <div class="th flex">
        <span translate>Created At</span>
        <bringoz-button *ngIf="allowSort"
                        type="tertiary"
                        size="lg"
                        (click)="sortTypeChangeEvent.emit('sortCreatedAt')">
          <bringoz-icon [iconName]="sortType?.name === 'sortCreatedAt' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>
      <div class="th flex" translate>Updated At</div>
      <div class="th flex-5"></div>
    </div>

    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport itemSize="60" class="flex viewport" (scroll)="getNextBatch()">
        <app-groups-table-row *cdkVirtualFor="let group of groups"
                              class="item"
                              [group]="group"
                              [allowEdit]="allowEdit"
                              [allowDelete]="allowDelete"
                              (editGroupEvent)="editGroupEvent.emit($event)"
                              (deleteGroupEvent)="deleteGroupEvent.emit($event)">
        </app-groups-table-row>
      </cdk-virtual-scroll-viewport>
    </div>

  </div>

</div>

